import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2GiveChipsConfigDialogProperties extends BasicDialogProperties {
    public playerId: number = 0;
    public chipsToGive: number = NaN;
    public playerName: string;

    constructor(playerId: number, chipsToGive: number, playerName: string = "") {
        super();

        this.playerId = playerId;
        this.chipsToGive = chipsToGive;
        this.playerName = playerName;
    }
}
